import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ListItemText, IconButton, Select as MuiSelect, MenuItem, Checkbox, Input, FormControl as MuiFormControl, withStyles, InputLabel, Typography } from '@material-ui/core';
import { Delete as DeleteIcon } from '@material-ui/icons';
import { ModuleTypeEnum, PluginManager } from '@kailona/core';
var FormControl = withStyles({
  root: {
    minWidth: '100%',
    maxWidth: 300
  }
})(function (props) {
  return /*#__PURE__*/React.createElement(MuiFormControl, props);
});
var Select = withStyles({
  root: {
    backgroundColor: '#fff',
    padding: '5px 8px',
    '&:hover, &:focus': {
      backgroundColor: '#fff !important'
    }
  }
})(function (props) {
  return /*#__PURE__*/React.createElement(MuiSelect, props);
});

var styles = function styles(theme) {
  return {
    importDataBrowser: {
      height: '100%',
      margin: '0 20px 20px 20px',
      backgroundColor: '#FFFFFF',
      border: '1px solid #EAEAEA',
      borderRadius: '5px'
    },
    fileItem: {
      width: '100%',
      display: 'flex',
      alignItems: 'center'
    },
    fileName: {
      flexBasis: '48%'
    },
    destination: {
      flexBasis: '48%'
    },
    deleteFile: {
      flexBasis: '4%'
    },
    selectBox: {
      '&:before': {
        borderColor: theme.palette.primary.main
      },
      '&:hover:not(.Mui-disabled):before': {
        borderColor: theme.palette.primary.main
      }
    },
    selectLabel: {
      marginTop: '-12px',
      fontSize: '15px',
      letterSpacing: '0.1px',
      fontWeight: '400',
      color: theme.palette.primary.main,
      '&.MuiInputLabel-shrink': {
        display: 'none'
      }
    },
    destinationCheckbox: {
      color: "".concat(theme.palette.primary.main, " !important")
    },
    icon: {
      fill: theme.palette.primary.main
    },
    deleteIcon: {
      fill: theme.palette.gray60.main
    }
  };
};

var FHIR = {
  id: 'FHIR',
  name: 'FHIR'
};

var ImportDataBrowser = /*#__PURE__*/function (_Component) {
  _inherits(ImportDataBrowser, _Component);

  var _super = _createSuper(ImportDataBrowser);

  function ImportDataBrowser() {
    var _this;

    _classCallCheck(this, ImportDataBrowser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "getDataTypeMenuItems", function (pluginIds) {
      var menuItems = [];
      var importOptions = [];
      var classes = _this.props.classes;
      PluginManager.plugins.forEach(function (plugin, index) {
        var id = plugin.id,
            name = plugin.name,
            modules = plugin.modules; // Skip if plugin does not support data import

        var dataModule = modules[ModuleTypeEnum.DataModule];

        if (!dataModule || typeof dataModule.importData !== 'function') {
          return;
        }

        importOptions.push({
          id: id,
          name: name
        });
      });
      importOptions.push(FHIR);
      importOptions.map(function (item, index) {
        var id = item.id,
            name = item.name;
        menuItems.push( /*#__PURE__*/React.createElement(MenuItem, {
          key: index,
          value: id,
          disableRipple: true
        }, /*#__PURE__*/React.createElement(Checkbox, {
          checked: pluginIds.includes(id),
          className: classes.destinationCheckbox
        }), /*#__PURE__*/React.createElement(ListItemText, {
          primary: name
        })));
      });
      return menuItems;
    });

    _defineProperty(_assertThisInitialized(_this), "getOptionNames", function (selectedOptionIds) {
      var optionNames = [];
      PluginManager.plugins.forEach(function (plugin) {
        var id = plugin.id,
            name = plugin.name;

        if (!selectedOptionIds.includes(id)) {
          return;
        }

        optionNames.push(name);
      });

      if (selectedOptionIds.includes('FHIR')) {
        optionNames.push('FHIR');
      }

      return optionNames.join(', ');
    });

    _defineProperty(_assertThisInitialized(_this), "getFileItems", function () {
      var _this$props = _this.props,
          files = _this$props.files,
          classes = _this$props.classes;
      return files.map(function (fileData) {
        var file = fileData.file,
            pluginIds = fileData.pluginIds;
        return /*#__PURE__*/React.createElement("div", {
          className: classes.fileItem
        }, /*#__PURE__*/React.createElement("div", {
          className: classes.fileName
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "h5"
        }, file.name)), /*#__PURE__*/React.createElement("div", {
          className: classes.destination
        }, /*#__PURE__*/React.createElement(FormControl, {
          variant: "outlined"
        }, /*#__PURE__*/React.createElement(InputLabel, {
          className: classes.selectLabel
        }, "Select"), /*#__PURE__*/React.createElement(Select, {
          className: classes.selectBox,
          MenuProps: {
            getContentAnchorEl: function getContentAnchorEl() {
              return null;
            }
          },
          multiple: true,
          placeholder: t('ehr', 'Select options'),
          value: pluginIds,
          onChange: function onChange(event) {
            return _this.props.onDataTypesChanged(file, event.target.value);
          },
          input: /*#__PURE__*/React.createElement(Input, {
            style: {
              margin: '0'
            }
          }),
          renderValue: function renderValue(selected) {
            return _this.getOptionNames(selected);
          },
          inputProps: {
            classes: {
              icon: classes.icon
            }
          }
        }, _this.getDataTypeMenuItems(pluginIds)))), /*#__PURE__*/React.createElement("div", {
          className: classes.deleteFile
        }, /*#__PURE__*/React.createElement(IconButton, {
          edge: "end",
          "aria-label": "delete",
          onClick: function onClick() {
            return _this.props.onFileRemove(file);
          }
        }, /*#__PURE__*/React.createElement(DeleteIcon, {
          className: classes.deleteIcon
        }))));
      });
    });

    return _this;
  }

  _createClass(ImportDataBrowser, [{
    key: "render",
    value: function render() {
      var classes = this.props.classes;
      return /*#__PURE__*/React.createElement("div", {
        className: classes.importDataBrowser,
        style: {
          padding: '10px 20px'
        }
      }, /*#__PURE__*/React.createElement("div", {
        key: "header",
        className: classes.fileItem
      }, /*#__PURE__*/React.createElement("div", {
        className: classes.fileName
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "body1"
      }, t('ehr', 'File name'))), /*#__PURE__*/React.createElement("div", {
        className: classes.destination
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "body1"
      }, t('ehr', 'Destination')))), this.getFileItems());
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return ImportDataBrowser;
}(Component);

_defineProperty(ImportDataBrowser, "propTypes", {
  files: PropTypes.arrayOf(PropTypes.shape({
    file: PropTypes.object.isRequired,
    pluginIds: PropTypes.array.isRequired
  })),
  onDataTypesChanged: PropTypes.func.isRequired,
  onFileRemove: PropTypes.func.isRequired
});

var _default = withStyles(styles)(ImportDataBrowser);

export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(FormControl, "FormControl", "/home/runner/html/nextcloud/apps/ehr/js/platform/main/src/components/ImportData/ImportDataBrowser.js");
  reactHotLoader.register(Select, "Select", "/home/runner/html/nextcloud/apps/ehr/js/platform/main/src/components/ImportData/ImportDataBrowser.js");
  reactHotLoader.register(styles, "styles", "/home/runner/html/nextcloud/apps/ehr/js/platform/main/src/components/ImportData/ImportDataBrowser.js");
  reactHotLoader.register(FHIR, "FHIR", "/home/runner/html/nextcloud/apps/ehr/js/platform/main/src/components/ImportData/ImportDataBrowser.js");
  reactHotLoader.register(ImportDataBrowser, "ImportDataBrowser", "/home/runner/html/nextcloud/apps/ehr/js/platform/main/src/components/ImportData/ImportDataBrowser.js");
  reactHotLoader.register(_default, "default", "/home/runner/html/nextcloud/apps/ehr/js/platform/main/src/components/ImportData/ImportDataBrowser.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();